export const END_POINT = process.env.NODE_ENV === "development" ? "http://localhost:3333" : "http://45.163.165.32:3333";

export const END_POINT_HASURA = process.env.NODE_ENV === "development" ? "localhost:8080/v1/graphql" : "192.168.10.10:8081/v1/graphql";

export const END_POINT_CALL_CENTER = "http://localhost:3332";
